import { useMemo, useState } from "react";
import Categories from "../Processes/conversations/utils/categories.json";
import { downloadFileHandler as downloadFile } from "~/utils/fileUtils";
import { useSelector } from "react-redux";

const useAddAttachments = (files, setFiles, type, regData) => {
  const [showUploadModal, setShowUploadModal] = useState(false);
  const { role } = useSelector((state) => state.login);

  const fileSupported = [
    "xls",
    "csv",
    "xml",
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "txt",
    "doc",
    "docx",
    "xlsx",
  ];

  const uploadFileHandler = (file) => {
    setFiles((prevFiles) => [...prevFiles, ...file]);
  };

  const getType = () => {
    const name = regData.preferred_name
      ? `${regData.preferred_name}`
      : `${regData?.name}${regData?.last_name ? " " + regData?.last_name : ""}`;
    return { name };
  };

  const getCategoryAndSubcategoryNames = (categoryCode, subCategoryCode) => {
    const category = Categories.find((cat) => cat.code === categoryCode);
    const subCategory = category?.subCategory?.find(
      (sub) => sub.code === subCategoryCode,
    );

    return {
      categoryName: category?.name || categoryCode,
      subCategoryName: subCategory?.name || subCategoryCode,
    };
  };

  const downloadFileHandler = async (file) => {
    await downloadFile(
      { blob_url: file.objectURL, name: file.fileName },
      "documents",
    );
  };

  const handleDelete = (rowData) => {
    const updatedFiles = files.filter(
      (obj) => JSON.stringify(obj) !== JSON.stringify(rowData),
    );
    setFiles(updatedFiles);
  };

  const officerAttachmentConfig = useMemo(() => {
    if (type === "officer") {
      return {
        attachmentDescription:
          "Upload and categorize supporting documents for this officer.",
        noDocUploadedDescription:
          "Upload supporting documents for this officer, such as ID or proof of address.",
      };
    } else if (type === "power-of-attorney") {
      return {
        attachmentDescription:
          "Upload and categorize supporting documents for this Attorney.",
        noDocUploadedDescription:
          "Upload supporting documents for this attorney, such as ID or proof of address.",
      };
    }
  }, [type]);

  return {
    showUploadModal,
    setShowUploadModal,
    fileSupported,
    uploadFileHandler,
    getType,
    getCategoryAndSubcategoryNames,
    downloadFileHandler,
    handleDelete,
    officerAttachmentConfig,
    role,
  };
};

export default useAddAttachments;
